<template>
    <div>
        <h2>支付测试</h2>
        <van-button type="primary" @click="wxPay()">点我支付</van-button>

    </div>
</template>

<script>
    import Vue from 'vue';
    import wx from "weixin-js-sdk";
    import {Dialog} from "vant";

    export default {
        data() {
            return {
                order_id: 16,
                appId:'',
                timeStamp:'',
            };
        },
        methods: {
            onBridgeReady() {
                let querystring = require("querystring");
                this.$api.post("wx/hmpay/order",
                    querystring.stringify({
                        order_id: this.order_id,
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        WeixinJSBridge.invoke('getBrandWCPayRequest', {
                                "appId": data.data.pay_data.appId,     //公众号ID，由商户传入
                                "timeStamp": data.data.pay_data.timeStamp,     //时间戳，自1970年以来的秒数
                                "nonceStr": data.data.pay_data.nonceStr,      //随机串
                                "package": data.data.pay_data.package,
                                "signType": data.data.pay_data.signType,     //微信签名方式：
                                "paySign": data.data.pay_data.paySign, //微信签名
                            },
                            function (res) {
                                if (res.err_msg == "get_brand_wcpay_request:ok") {
                                    // 使用以上方式判断前端返回,微信团队郑重提示：
                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                }
                            });
                    } else {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {

                        });
                    }
                });
                console.log(this.timeStamp);

            },
            wxPay() {
                if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                    }
                } else {
                    this.onBridgeReady();
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/container-yard/pay.vue